import React from 'react';
import PropTypes from 'prop-types';
import BaseDialog from '../../../../../components/BaseDialog/BaseDialog';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';

import { getString } from '../../../../../helpers/stringHelpers.js';
import Replace from '../../../../../components/Replace/Replace';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

class TooManyConsentsDialog extends React.Component {
  render() {
    const { classes, open, confirm } = this.props;

    const stringsComponent = 'consentedPersons';

    return (
      <div className={classes.root}>
        <BaseDialog
          open={open}
          title={getString(stringsComponent, 'TOO_MANY_CONSENTS_TITLE')}
          content={
            <Replace
              content={getString(stringsComponent, 'TOO_MANY_CONSENTS_CONTENT')}
              toReplace='0800 801 601'
              replaceWith={
                <a className={classes.link} href='tel:0800 801 601'>
                  0800 801 601
                </a>
              }
            />
          }
          buttonAction={confirm}
          buttonLabel={getString(stringsComponent, 'OK_BUTTON_LABEL')}
          icon={ReportProblemOutlinedIcon}
        />
      </div>
    );
  }
}

TooManyConsentsDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool,
  confirm: PropTypes.func,
};

TooManyConsentsDialog.defaultProps = {
  open: false,
};

export default withStyles(styles, { withTheme: true })(TooManyConsentsDialog);
